import { withTargetValue } from '@ipfabric/ui-components/utils/events/withTargetValue';
import classNames from 'classnames';
import { DateTimePicker } from 'components/DateTimePicker/DateTimePicker';
import { useRuleContext } from 'components/Table/components/AdvancedFilter/useRuleContext';
import { TextInput } from 'components/TextInput/TextInput';
import { format } from 'date-fns';
import { useState } from 'react';
import type { FC } from 'react';

interface Props {
  hasError: boolean;
  onValueChange: (value: string) => void;
  onBlur: () => void;
  value: string;
}

export const DateTimeFilterRule: FC<Props> = (props) => {
  const [calendarOpen, setCalendarOpen] = useState<boolean>(false);
  const ruleContext = useRuleContext();

  const datePickerChanged = (value: number) => {
    props.onValueChange(format(value, ruleContext.dateFormat));
  };

  return (
    <div className='flex h-8 items-center gap-4'>
      <TextInput
        hasError={props.hasError}
        value={props.value}
        onChange={withTargetValue(props.onValueChange)}
        onBlur={props.onBlur}
        type='text'
        size='small'
      />
      <i
        onClick={() => setCalendarOpen(true)}
        className={classNames(
          'fa fa-calendar-days',
          'ipf-table-header-date-time-calendar-icon',
          'cursor-pointer',
        )}
      />
      {calendarOpen && (
        <DateTimePicker
          onChange={({ value }) => datePickerChanged(value)}
          onClose={() => setCalendarOpen(false)}
          value={props.value}
          inputDateFormats={[
            ruleContext.dateFormat,
            ruleContext.dateTimeFormat,
          ]}
          outputDateFormat={ruleContext.dateFormat}
          timezone={ruleContext.timezone}
          withoutComaparator
        />
      )}
    </div>
  );
};
